import { EllipsisVerticalIcon } from 'lucide-react';
import { useState } from 'react';

import { type PaymentStatusWithoutAll } from '~entities/parent/model/payment.type';
import { PaymentStatus } from '~entities/payment/constants/index';
import { useCurrentUserRole } from '~entities/users/hooks/use-current-user-role';

import { Button } from '~shared/shadcn/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~shared/shadcn/ui/dropdown-menu';

import { AddStudent } from './add-student';
import { CancelInvoice } from './cancel-invoice';

interface TransactionsTableActionsProps {
  invoiceId: string;
  paymentProvider: string;
  parentId: string;
  studentId: string;
  status: PaymentStatusWithoutAll;
}

export const TransactionsTableActions = ({
  invoiceId,
  paymentProvider,
  parentId,
  studentId,
  status,
}: TransactionsTableActionsProps) => {
  const [open, setOpen] = useState(false);

  const isGHL = paymentProvider === 'ghl';
  const { hasAdminAccess } = useCurrentUserRole();
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant='ghost'
          size='icon'
          disabled={!hasAdminAccess}
          title={
            !hasAdminAccess
              ? 'Studio Admin access is required for invoice actions'
              : undefined
          }
        >
          <EllipsisVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='flex flex-col gap-2' align='end'>
        {[
          PaymentStatus.SCHEDULED,
          PaymentStatus.FREE,
          PaymentStatus.UPCOMING,
          PaymentStatus.FAILED,
          PaymentStatus.INVOICE_SCHEDULED,
        ].includes(status) && (
          <DropdownMenuItem asChild>
            <CancelInvoice invoiceId={invoiceId} isGHL={isGHL} />
          </DropdownMenuItem>
        )}
        <DropdownMenuItem asChild>
          <AddStudent
            parentId={parentId}
            invoiceId={invoiceId}
            studentId={studentId}
          />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
